import { useEffect, useRef } from 'react';
import type { ApplicationManifest, ApplicationProps } from '@/applications/types';
import { DEFAULT_CAPABILITIES } from '@/applications/types';
import { asApplicationId } from '@/types';
import styles from './NotesApp.module.css';

/**
 * A plain-text scratchpad. It is the reference application: it shows how state
 * flows in (props) and out (setState → command) without the app touching stores.
 */
export const NotesApp = ({ state, setState, active }: ApplicationProps) => {
  const text = typeof state.text === 'string' ? state.text : '';
  const ref = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    if (active && ref.current && document.activeElement === document.body) ref.current.focus({ preventScroll: true });
  }, [active]);
  return (
    <textarea
      ref={ref}
      className={styles.editor}
      value={text}
      placeholder="Write something…"
      spellCheck={false}
      onChange={(e) => {
        setState({ ...state, text: e.target.value });
      }}
    />
  );
};

export const notesManifest: ApplicationManifest = {
  id: asApplicationId('app.notes'),
  name: 'Notes',
  version: '1.1.0',
  icon: '✎',
  category: 'productivity',
  description: 'Plain-text scratchpad that lives in the world.',
  defaultSize: { width: 420, height: 320 },
  defaultPosition: 'cascade',
  capabilities: DEFAULT_CAPABILITIES,
  component: NotesApp,
  normalizeState: (state) => ({ text: typeof state.text === 'string' ? state.text : '' }),
};
